import React from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';

interface Props {}

const N: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.N');

    return (
        <section
            id="rapid-mag-N"
            className={`rapid-mag-N ${css.section} GtmModuleData-section`}
            data-section-id={'rapid-mag-N'}
            data-section-title={t('title')}
        >
            <div className="img">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1749019760018/15.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1749019760018/15.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1749019774120/15_M.jpg"
                />
            </div>
            <div className="info">
                <p className="title">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
            </div>
            <ul className="tips">
                <li className="tip">{t('tip1')}</li>
                <li className="tip">{t('tip2')}</li>
            </ul>
        </section>
    );
};
export default N;
